import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TenantContextService {
  private readonly tenantKey = 'tenantId';
  private readonly aliasKey = 'tenantAlias';

  getTenantId(): string | undefined {
    const stored = localStorage.getItem(this.tenantKey);
    return stored ?? undefined;
  }

  getTenantAlias(): string | undefined {
    const stored = localStorage.getItem(this.aliasKey);
    return stored ?? undefined;
  }

  setTenantContext(tenantId: string, tenantAlias?: string): void {
    if (!tenantId) {
      return;
    }
    localStorage.setItem(this.tenantKey, tenantId);
    if (tenantAlias) {
      localStorage.setItem(this.aliasKey, tenantAlias);
    }
  }

  clearTenantId(): void {
    localStorage.removeItem(this.tenantKey);
    localStorage.removeItem(this.aliasKey);
  }

  getTenantIdOrFallback(): string {
    return this.getTenantId() ?? environment.tenantId ?? 'oculus-dev';
  }

  getTenantRouteSegment(): string {
    return this.getTenantAlias() ?? this.getTenantIdOrFallback();
  }

  getTenantIdFromUrl(url: string): string | undefined {
    const match = url.match(/\/tenant\/([^/]+)/);
    return match?.[1];
  }
}
